import React from 'react';
import ReactDOM from 'react-dom';
import './MainBody.css'
import Projects from "./Projects"
import WorkExp from "./WorkExp"
import Skills from "./Skills"
import WhoAmI from "./WhoAmI"
import Honor from "./Honor"
import salman from "./salman.jpg"
import uga from "./Images/UGA.jpg"
import LU from "./Images/LU.jpeg"


class MainBody extends React.Component {
  render (){
    return (
      <div>
        <div class="container-fluid bg-1 text-center">
          <div class="row">
            <div class="col-sm-6">
              <h1>Salman Farhat  (outdated)</h1>
              <img src={salman} class="img-circle" width="250px" height="250px"  />
              <h3>I turn caffeine into code.</h3><hr width="50%" />
              <a href="https://salmanpersonal.000webhostapp.com/SalmanCV.pdf" target="blacked" class="doCV">Download my resume :)</a><hr width="50%" />

            </div>
            <div class="col-sm-6 text-left vertical" >

              <h3>Université Grenoble Alpes</h3>
              <p><img src={uga}  width="100px" height="100px"  align="left" class="marginRigh"/> <b class="biggertext"> Master M2 Student in Parallel and Distributed Systems at UGA.<br /> Master M1 in Computer Science (MOSIG) at UGA</b></p><br/><br/>
              <hr width="100%" />
              <h3>Lebanese University</h3>
              <p><img src={LU}  width="100px" height="100px"  align="left" class="marginRigh"/> <b class="biggertext"> bachelor degree at Lebanese University</b></p>
            </div>
          </div>
        </div>
        <WhoAmI />
        <WorkExp />
        <Projects />
        <Honor/>
        <Skills />
      </div>
    )
  }
}

export default MainBody;
